import React from "react";
import styled from "styled-components";
import Boton from "../eventos/Boton";
import LinksFooter from "../eventos/LinksFooter";

//Footer generico de todas las páginas
const Footer = () => {
  return (
    <>
      {/* <Footer1>
        <EstiloH1 className="mb-4" letra="true">
          SUBSCRÍBETE A <b>NUESTRA NEWSLETTER</b>
        </EstiloH1>
        <EstiloP className="mb-4" color="gris">
          Te mantendremos informado de todos los cursos subvencionados
          nuevos que publiquemos y sus fechas de inicio.
        </EstiloP>
        <Boton to="https://app.mdirector.com/render-subscription-form/empId/64871/formId/7/lang/es">SUSCRÍBETE</Boton>
      </Footer1> */}
      <Footer2>
        <LinksFooter to="/aviso-legal">Aviso Legal</LinksFooter>.
        <LinksFooter to="/politica-de-privacidad">Política de Privacidad</LinksFooter>.
        <LinksFooter to="/politica-de-cookies">Política de Cookies</LinksFooter>.
      </Footer2>
    </>

  );
};

export default Footer;

const Footer1 = styled.div`
  margin-top:5% ;
  width: 100%;
  height: 300px;
  background-color: #efefef;
  text-align: center;
  padding: 3%;
  margin-bottom: 1%;
  
`;

const EstiloH1 = styled.h2`
  font-family: ${({ letra }) => (letra = "true" ? "'Dosis'" : "'sans-serif'")};
  color: black;
  b{
    font-weight: 600;
  }
`;


const EstiloP = styled.p`
  color: grey;
  font-weight: 600;
  
`;

const Footer2 = styled.div`
/* margin-top: 10px; */
   margin-top: 50px;
   padding-top: 10px;
   width: 100%;
   height: 80px;
   text-align: center;

   
   

`


